<template>
  <div class="office-item"
       @click="itemClick">
    <div class="left fl">
      <span v-if="nameIcon"><img :src="nameIcon"></span>
      <span v-else>{{xy.showName(name)}}</span>
    </div>
    <div class="right">
      <div class="title">
        <div class="nowrap tit">{{name}}提交了公文</div>
        <div class="date fr">{{new Date(officeDate.replace(/-/g, '/')).pattern('yyyy-MM-dd  HH:mm')}}</div>
      </div>
      <div class="type">公文种类：{{officeType}}</div>
      <div class="nowrap theme">主题：{{officeTheme}}</div>
      <!-- 传入-1不展示此项（公文归档） -->
      <div class="status"
           v-if="status !== -1"
           :style="{color: (status === 0 ? '#4196FF' : status === 1 ? '#E8A022' : status === 2 ? '#21A83E' : status === 3 ? '#D83737' : status === 4 ? '#666666' : '')}">
        {{status === 0 ? '待审批' : status === 1 ? '审批中' : status === 2 ? '已通过' : status === 3 ? '已拒绝' : status === 4 ? '已收回' : ''}}
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    nameIcon: {
      type: String,
      default: ''
    },
    officeTitle: {
      type: String,
      default: ''
    },
    officeTheme: {
      type: String,
      default: ''
    },
    officeType: {
      type: String,
      default: ''
    },
    officeDate: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: 0
    }
  },
  name: "OfficeItem",
  data () {
    return {};
  },
  methods: {
    itemClick () {
      this.$emit('itemClickHandler')
    }
  }
};
</script>
<style lang="less" scoped>
.office-item {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
  margin-bottom: 16px;
  padding: 12px 31px 22px 19px;
  .left {
    width: 64px;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      overflow: hidden;
      text-align: left;
      border-radius: 50%;
      background: @blue;
      font-size: 26px;
      color: #fff;
      > img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
      }
    }
  }
  .right {
    padding-left: 87px;
    .title {
      display: flex;
      justify-content: space-between;
      .tit {
        flex: 1;
        max-width: 60%;
        font-size: 30px;
        line-height: 64px;
        font-weight: bold;
        color: #333;
      }
      .date {
        line-height: 64px;
        color: #b4b4b4;
        font-size: 24px;
      }
    }
    .type {
      font-size: 24px;
      color: #999;
      width: fit-content;
      height: 36px;
      line-height: 36px;
      padding: 0 20px 0 11px;
      margin-bottom: 15px;
      background: rgba(249, 249, 249, 1);
      border-radius: 14px 0px 14px 0px;
    }
    .theme {
      font-size: 28px;
      margin: 8px 0 20px;
      color: #666;
    }
    .status.pass {
      color: #21a83e;
    }
  }
}
</style>